import { RenewalLineOut } from '../../../store/api';
import { SubscriptionRenewalLineUpdateRequest } from '../../../api/subscription-management/renewals/updateRenewalLine';
import { RenewalLine, RenewalType, RenewalTypes } from '../utils/renewalTableTileTypes';
import { formatRenewalType } from '../utils/formatRenewalType';
import { formatUsageLimit } from '../../../shared/utils/formatUsageLimit';
import { renewalTypeFromString } from '../utils/renewalTypeFromString';
import i18n from '../../../../i18n';
import { t } from 'i18next';
import FormatCurrency from '../../../shared/utils/formatCurrency';

export const mapRenewalLine = (
    renewal: RenewalLineOut,
    spocCurrency: string,
    onRenewalLineUpdate: (params: SubscriptionRenewalLineUpdateRequest) => void
): Omit<RenewalLine, 'selectedType' | 'type'> => {
    const typeList: RenewalTypes[] = renewal.types.map(item => {
        const type = renewalTypeFromString(item.type);
        return {
            type,
            label: formatRenewalType(type),
            selected: item.selected,
            usageLimit: mapRenewalLineUsageLimit(type, item.usageLimit),
            enabled: item.enabled,
            infoMessage: item.infoMessage
        };
    });

    return {
        types: typeList,
        onRenewalLineUpdate,
        items: renewal.lineItems,
        total: renewal?.totalPrice
            ? {
                  priceLabel: t('numberFormat.numberWithCurrencySymbol', {
                      val: FormatCurrency.convertIntegerToCurrencyFormat(renewal.totalPrice),
                      currencySymbol: FormatCurrency.mapCurrencyToSymbol(spocCurrency)
                  }),
                  usageLimitLabel: formatUsageLimit(renewal.totalUsageLimit)
              }
            : undefined
    };
};

export const mapRenewalLineUsageLimit = (type: RenewalType, usageLimit?: number | null): string | undefined => {
    if (type === RenewalType.RECOMMENDED || type === RenewalType.SAME_AS_CURRENT_YEAR) {
        return usageLimit !== null
            ? usageLimit === 0
                ? i18n.t('shop.subscriptions.unlimited')
                : usageLimit?.toString() ?? '0'
            : '0';
    } else {
        return usageLimit ? usageLimit.toString() : undefined;
    }
};
